import { Redirect } from 'expo-router';
import Head from 'expo-router/head';

import LoyaltyDashboardPage from '@fhs-legacy/frontend/src/pages/loyalty/loyalty-dashboard';
import { useFlag } from '@fhs-legacy/frontend/src/utils/launchdarkly';
import { routes } from '@fhs-legacy/frontend/src/utils/routing';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function DetailsPage() {
  const enableRewardsTiers = useFlag('enable-rewards-tiers');
  if (enableRewardsTiers) {
    return <Redirect href={`${routes.offersV2}?section=rewards`} />;
  }

  return (
    <>
      <Head>
        <title>Rewards - Firehouse Subs</title>
      </Head>
      <LoyaltyDashboardPage />
    </>
  );
}
